import styled from 'styled-components'
import { iPadDown } from '../../../styles/mediaQueries'
import { DolaThemes } from '../../../styles/types'
import { modalBorderRadius, modalBorderRadiusMobile } from './SliderModal'
import globalTheme from '../../../styles/theme'

export interface ModalProps {
  closing: boolean
  dolaTheme: DolaThemes
  visible: boolean
}

const ClassicModal = styled.div<ModalProps>`
  background: ${({ dolaTheme }) => globalTheme[dolaTheme].background};
  border-radius: ${modalBorderRadius};
  opacity: ${({ closing, visible }) => (closing || visible ? 1 : 0)};
  overflow: hidden;
  position: fixed;
  transition: opacity 0.4s ease;
  width: 0;
  left: calc(50% - 10.94vw);
  top: calc(50% - 14.45vw);
  width: 21.88vw;
  z-index: 10001;

  ${iPadDown} {
    border-radius: ${modalBorderRadiusMobile};
    height: 66vh;
    left: calc(50% - 45vw);
    top: calc(50% - 33vh);
    width: 90vw;
  }
`

export default ClassicModal
